import { all } from 'redux-saga/effects';
import createPostSaga from './watchers/createPost';
import getPostTopics from './watchers/getPostTopics';

function* competencesSaga() {
  yield all([createPostSaga(), getPostTopics()]);
}

export default competencesSaga;
